import {Component, Input, OnInit} from '@angular/core';
import {animate, animateChild, query, stagger, style, transition, trigger} from '@angular/animations';
import {SmartDogTrainer} from '@model/product/smart-dog-trainer/smart-dog-trainer.model';

@Component({
  selector: 'app-smart-dog-trainer',
  templateUrl: './smart-dog-trainer.component.html',
  styleUrls: ['./smart-dog-trainer.component.scss', '../../user/customer/customer.component.scss'],
  animations: [
    trigger('slide', [
      transition('void => *', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('0.1s ease-in'),
      ]),
    ]),
    trigger('fade', [
      transition('void => *', [style({ opacity: 0 }), animate(200)]),
    ]),
    trigger('stagger', [
      transition('void => *', [
        query('div', stagger('-.005s ease-in', [animateChild()])),
      ]),
    ]),
  ],
})
export class SmartDogTrainerComponent implements OnInit {

  @Input()
  smartDogTrainer: SmartDogTrainer = null;

  ngOnInit(): void {
  }

}
